define([
	"dojo/_base/declare",
	"csi",
	"csi/action/Controller",
	"csi/gallery/_base",
	"csi/service/writerService",
	"csi/xml"
], function(declare, csi, Controller, {getGroupColumn, getGroupRow}, {writeAggregateStoreOperation}, xml) {

	return declare(Controller, {
		bHold: false,
		bModal: true,
		bShowWait: true,

		// Source: target of drop
		//dndTarget: null,

		// Source: source of items to drop
		//dndSource: null,

		// DOMNode[]: nodes dropped
		//dndNodes: nodes,

		/** @property {cnl[]} _changedUrls - list of urls dragged to new group */
		_changedUrls: null,

		/**
		 * @override
		 * Write operations to change attribute values of nodes to those in new group
		 */
		toWriter() {
			const {
				dndNodes,
				dndSource,
				dndTarget,
				widget,
			} = this;

			const {
				_groupColSpec,
				_groupColValues,
				_groupRowSpec,
				_groupRowValues,
				_selectionColumnStore,
				_selectionRowStore,
			} = widget;

			const column1 = getGroupColumn(dndSource.node);
			const column2 = getGroupColumn(dndTarget.node);
			const row1 = getGroupRow(dndSource.node);
			const row2 = getGroupRow(dndTarget.node);
			const ctx = widget.getContext(csi.EMPTY_URL);

			this._changedUrls = dndNodes.map((domNode) => {
				const refNode = widget.getRefNode(domNode);
				const url = widget.getRefNodeUrl(refNode);
				ctx.setNodeURL(url, true);

				if (column1 != column2) {
					this._writeChange(ctx, _groupColSpec, _groupColValues, column2, _selectionColumnStore);
				}

				if (row1 != row2) {
					this._writeChange(ctx, _groupRowSpec, _groupRowValues, row2, _selectionRowStore);
				}

				return url;
			});
		},

		/**
		 * @override
		 * Redraw cards that were changed
		 */
		postProcessSuccess() {
			const {widget, _changedUrls} = this;

			_changedUrls.forEach((url) => {
				const refNode = widget.getRefNodeByUrl(url);
				widget.redrawNode(refNode);
			});
		},

		/**
		 * Write operation(s) to change the attribute value of the node in context
		 * @param {Context} ctx 
		 * @param {Spec} spec 
		 * @param {Values} valuesStore 
		 * @param {number} index 
		 * @param {StoreNames} aggregateStore
		 */
		_writeChange(ctx, spec, valuesStore, index, aggregateStore) {
			const {m_writer, widget} = this;
			const {heading, type} = spec;
			const v = widget._getDndGroupedSourceValue(index, spec, valuesStore, aggregateStore);

			if (ctx.push(heading.m_path)) {
				// apply new value based on attribute type
				if (aggregateStore) {
					writeAggregateStoreOperation(m_writer, aggregateStore.aggregateStoreResponse, [].concat(v));
				} else {
					const id = heading.m_id;
					const node = ctx.getNode();
					const cn = m_writer.changeNode(node.$URL).changeAttribute(id, type, v);

					if (xml.nodeAttributeHasExpression(node, id, true)) {
						cn.disableAttributeExp(id);
					}
				}

				ctx.pop();
			}
		}
	});
});